import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { RefreshStatusProps } from "models/propTypes/allCompaniesPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Icon, RoundButton } from "components/common";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const getRefreshedAtText = (refreshedAt: Date) => {
  const sameDay = DateHelper.resetTime(refreshedAt)?.getTime() === DateHelper.resetTime(new Date())?.getTime();
  return LocalizationHelperInstance.getFormattedDate(refreshedAt, {
    ...(sameDay ? {} : { day: "numeric", month: "short" }),
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
};

/** "Uppdaterad 14:32" with a reload icon button, for the whole overview. */
const RefreshStatus: React.FC<RefreshStatusProps> = (props) => {
  const { refreshedAt, refreshing, onRefresh } = props;

  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      columnGap={0}
      className={cssExports.allCompaniesTodoOverviewRefreshedAt}
    >
      {refreshedAt ? (
        <span>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.AllCompaniesRefreshedAt, undefined, {
            time: getRefreshedAtText(refreshedAt),
          })}
        </span>
      ) : (
        <></>
      )}
      <RoundButton
        className={clsx(cssExports.ghost, refreshing ? cssExports.allCompaniesRefreshing : undefined)}
        size="xs"
        displayType={StyleEnums.DisplayType.None}
        hoverText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.AllCompaniesRefresh)}
        hoverTextAsToolTip
        onClick={() => !refreshing && onRefresh()}
        testId="allCompaniesRefreshButton"
      >
        <Icon icon={IconDefinitionConstants.WReset} />
      </RoundButton>
    </Grid>
  );
};

export default RefreshStatus;
